import { render, staticRenderFns } from "./UpdatesType.vue?vue&type=template&id=1677bc49&scoped=true&"
import script from "./UpdatesType.vue?vue&type=script&lang=js&"
export * from "./UpdatesType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1677bc49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1677bc49')) {
      api.createRecord('1677bc49', component.options)
    } else {
      api.reload('1677bc49', component.options)
    }
    module.hot.accept("./UpdatesType.vue?vue&type=template&id=1677bc49&scoped=true&", function () {
      api.rerender('1677bc49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/timeline/partials/UpdatesType.vue"
export default component.exports